export default "__VITE_ASSET__Mv22rahH__"